import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import classNames from 'classnames';
import SideBar, { drawerWidth } from '../components/SideBar';
import Navbar from '../components/Navbar';

const styles = (theme) => ({
	root: {
		display: 'flex',
	},
	drawerHeader: {
		display: 'flex',
		alignItems: 'center',
		padding: '0 8px',
		...theme.mixins.toolbar,
		justifyContent: 'flex-start',
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		marginLeft: -drawerWidth,
	},
	contentShift: {
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginLeft: 0,
	},
});

class Wrapper extends React.Component {
	state = {
		open: false,
		profile: {},
	};

	componentDidMount() {
		const { auth } = this.props;
		const { userProfile, getProfile } = auth;
		if (!userProfile) {
			getProfile((err, profile) => {
				this.setState({ profile });
			});
		} else {
			this.setState({ profile: userProfile });
		}
	}

	handleDrawer = () => {
		this.setState((prevState) => ({
			open: !prevState.open,
		}));
	};

	render() {
		const { classes, auth, children } = this.props;
		const { open, profile } = this.state;
		return (
			<div className={classes.root}>
				<CssBaseline />
				<Navbar
					profile={profile}
					open={open}
					auth={auth}
					handleDrawer={this.handleDrawer}
				/>
				<SideBar auth={auth} open={open} />
				<main
					className={classNames(classes.content, {
						[classes.contentShift]: open,
					})}
				>
					<div className={classes.drawerHeader} />
					{children}
				</main>
			</div>
		);
	}
}

export default withStyles(styles, { withTheme: true })(Wrapper);
